import type Call from "src/models/call";
import type { LoggerContext } from "src/services/logger";

export type TwilioFlow = "video" | "reversa";

type TwilioLogContextFactoryParams = {
  callDetails: Call | null;
  twilioFlow: TwilioFlow;
  roomName: string | null;
};

export const getParticipantRole = (participant: any) => (participant.identity === "supervisor" ? "supervisor" : participant.identity?.indexOf("uda") > -1 ? "uda" : "other");

export const createTwilioLogContextFactory =
  ({ callDetails, twilioFlow, roomName }: TwilioLogContextFactoryParams) =>
  (extra?: LoggerContext): LoggerContext => ({
    callId: callDetails?.id ?? null,
    aderenteSlug: callDetails?.aderenteSlug ?? null,
    callType: callDetails?.callType ?? null,
    twilioFlow,
    roomName: roomName ?? null,
    ...extra,
  });